import Component, { ComponentLoader } from '@bythepixel/component-loader';
import CardFiltering from '@Components/cardFiltering';
import { eventThrottle } from '@Front/utility/index';
import DEFAULTS from './_config';

export default class BlogIndex extends Component {
  static selector = '[data-comp-blog-index]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.selectors = this.$options.selectors;

    // Don't initialize filtering on blog category pages
    if (!window.location.pathname.includes('/c/')) {
      this.cardFiltering = new CardFiltering(this.$container.querySelector(this.selectors.cardFiltering));
      this.checkboxes = this.cardFiltering.getCheckboxes();
    }

    this.cardsContainer = this.$container.querySelector(this.selectors.cards);
    this.moreButton = this.$container.querySelector(this.selectors.moreButton);
    this.moreButtonDefaultText = this.moreButton?.innerText;
    this.moreSection = this.$container.querySelector(this.selectors.moreSection);

    let initialOffset = 0;
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');
    if (page) {
      initialOffset = 8 * parseInt(page, 10);
    }

    this.$state = {
      loading: false,
      offset: initialOffset,
      categoryId: this.$container
        .querySelector(this.selectors.categoryId)
        .dataset
        .compCardFilteringMoreCategory,
    };

    this.initializeListeners();
  }

  initializeListeners() {
    this.moreButtonListener();
    this.checkboxListeners();
  }

  moreButtonListener() {
    if (!this.moreButton) {
      return;
    }

    this.moreButton.addEventListener('click', eventThrottle(() => this.getMorePosts(), 250));
  }

  // When user selects/deselects categories, check to see if the more button should be displayed
  checkboxListeners() {
    if (this.checkboxes.length === 0) {
      return;
    }

    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const newOffset = this.$state.offset + 8;

        fetch(this.getUrl(newOffset))
          .then((response) => response.json())
          .then(data => {
            this.moreSection.style.display = data.more ? '' : 'none';
          });
      });
    });
  }

  getMorePosts() {
    if (this.$state.loading) {
      return;
    }

    this.$state.loading = true;

    this.updateMoreButtonLabel('Loading...');

    const newOffset = this.$state.offset + 8;

    fetch(this.getUrl(newOffset))
      .then((response) => response.json())
      .then(data => {
        if (!data.more) {
          this.moreSection.style.display = 'none';
        }

        const wrapper = document.createElement('div');
        wrapper.innerHTML = data.html;
        wrapper.childNodes.forEach(node => {
          this.cardsContainer.append(node);
        });

        this.resetMoreButtonLabel();
        this.$state.offset = newOffset;
        this.$state.loading = false;

        let searchParams;

        if (!window.location.search) {
          searchParams = new URLSearchParams(window.location.search);
          searchParams.set('page', 2);
        } else {
          searchParams = new URLSearchParams(window.location.search);
          const page = parseInt(searchParams.get('page'), 10) + 1;
          searchParams.set('page', page);
        }

        window.history.pushState(null, '', `?${searchParams}`);

        if (this.cardFiltering) {
          this.cardFiltering.toggleVisibility(this.$container.querySelectorAll(this.selectors.card));
        }
      });
  }

  updateMoreButtonLabel(newLabel) {
    requestAnimationFrame(() => {
      this.moreButton.innerText = newLabel;
    });
  }

  resetMoreButtonLabel() {
    requestAnimationFrame(() => {
      this.moreButton.innerText = this.moreButtonDefaultText;
    });
  }

  getUrl(newOffset) {
    let url = `/blog/more/${newOffset}/`;

    if (this.$state.categoryId) {
      url = `${url}${this.$state.categoryId}/`;
    }

    return url;
  }
}

window.blogComponents = new ComponentLoader(document, [BlogIndex]);
